<atom-modal-wrapper
    [modalId]="IMPORT_FORM_MODAL"
    [modalTemplate]="importFormModal"
>
    <ng-template #importFormModal>
        <organism-modal modalTitle="File Import" (modalClosed)="onClose()">
            <section
                class="form-action-buttons px-4 py-2 active-component d-flex align-items-center justify-content-end"
            >
                <button
                    type="button"
                    class="btn btn-outline-primary me-2"
                    (click)="onClose()"
                >
                    Cancel
                </button>

                <atom-async-button
                    btnClass="btn btn-primary"
                    [isLoading]="isLoadingData"
                    [disabled]="isLoadingData || !files?.length"
                    (onClick)="onClick()"
                >
                    Save
                </atom-async-button>
            </section>

            <section class="form-container">
                <wdx-form-field
                    [label]="
                        'DASHBOARD_LABEL_FILE_UPLOADER'
                            | translateTokenisedString
                    "
                    [guidanceText]="
                        'FILE_UPLOADER_GUIDANCE_TEXT' | translateTokenisedString
                    "
                    [isRequired]="true"
                >
                    <ngx-dropzone
                        #drop
                        class="d-flex flex-column justify-content-center"
                        [accept]="'text/csv,xls'"
                        [multiple]="false"
                        [disableClick]="true"
                        (change)="onSelect($event)"
                    >
                        @if (!files?.length) {
                            <div class="text-center body-text-medium">
                                <div>Drag and drop your file here</div>
                                <div>or</div>
                            </div>
                            <div class="d-flex justify-content-center">
                                <atom-icon-button
                                    class="mx-1"
                                    icon="file-upload"
                                    (click)="drop.showFileSelector()"
                                ></atom-icon-button>
                            </div>
                        }

                        @for (f of files; track $index) {
                            <ngx-dropzone-preview
                                [removable]="true"
                                (removed)="onRemove(f)"
                            >
                                <ngx-dropzone-label>
                                    {{ f.name }} ({{ f.type }})
                                </ngx-dropzone-label>
                            </ngx-dropzone-preview>
                        }
                    </ngx-dropzone>
                </wdx-form-field>
            </section>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
